export const Z_INDEX_MAP = {
    negative: -1,
    underline: 0,
    base: 10,
    overBase: 20,
    dropdown: 21,
    max: 100,
};
